function Card({ children, className = "" }) {

  return (
	    <div
	      className={`
	        bg-white
	        rounded-lg
	        border
	        border-slate-200
	        shadow-sm
	        p-4
	        mb-4
          ${className}
	      `}
    >
      {children}
    </div>
  );
}

export default Card;
